import {
  RecordIconIdentifierContainer,
  IRecordIconIdentifierContainerProps,
} from './RecordIconIdentifierContainer';

import { TStatus } from './types';

export interface ITimelineFeedBarProps
  extends IRecordIconIdentifierContainerProps {
  status: TStatus;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a timeline which contains a icon and a line
 */
export function TimelineFeedBar({
  source,
  status,
}: Readonly<ITimelineFeedBarProps>) {
  return (
    <div className="flex flex-col items-center">
      <div>
        <RecordIconIdentifierContainer source={source} status={status} />
      </div>
      <div className="h-full w-px border-s border-gray-200" />
    </div>
  );
}
